import { IonButton } from "@ionic/react";
import styled from "styled-components";

export const FloatingButton = styled(IonButton).attrs({ slot: "fixed" })`
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
`;
